import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class WorkGroupsService extends DataService {
  private baseURI = this.apiUri + '/workgroups/';
  private observable$: any;

  constructor(http: HttpClient) {
    super(http);
  }

  getWorkGroupsByAgencyMasterId(agencyMasterId): Observable<any> {
    this.setUri(this.baseURI);
    let params: HttpParams = new HttpParams();
    params = params.set('agencyMasterId', '' + agencyMasterId);
    return this.get({params});
  }

  updateWorkGroups(workGroup: string, newList: any, oldList: any) {
    return this.http.post(this.baseURI + 'update/' + workGroup, [newList, oldList]);
  }

  getUsersByWorkGroup(agencyCode, bureauCode, workGroup): Observable<any> {
    this.setUri(this.baseURI + 'workgroupusers/');
    let params: HttpParams = new HttpParams();
    params = params.append('agencyCode', agencyCode);
    params = params.append('bureauCode', bureauCode);
    params = params.append('workGroup', workGroup);
    return this.get({params});
  }

  updateTransactionAccessRights(transactionAccessRights) {
    return this.http.post(this.baseURI + 'transactionaccessrights/update/', transactionAccessRights);
  }
}
